<script>
  import { getStores } from '$app/stores';
  
  const { page } = getStores();
  export let src = '/CommerceBearLogo.svg';
</script>

<img class='logo' src={src} alt={$page.data.session?.env.APP_NAME} />

<style>
  .logo {
    width: var(--Logo--size);
    display: inline;
  }
</style>
